import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.VARS = {
      mode: this.DOM.view.dataset.mode,
    };
    console.log();

    this.instance = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top top",
      onEnter: () => {
        if (this.VARS.mode == "show") {
          Env.$html.classList.add("addtocart-sticky");
        } else {
          Env.$html.classList.remove("addtocart-sticky");
        }
      },
      onEnterBack: () => {
        if (this.VARS.mode == "show") {
          Env.$html.classList.remove("addtocart-sticky");
        } else {
          Env.$html.classList.add("addtocart-sticky");
        }
      },
    });
  }

  unmount() {
    this.instance.kill();
  }
}
